import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateValuePipe } from './translate-value.pipe';

@Pipe({
    name: 'splitAndTranslate',
    standalone: true,
})
export class SplitAndTranslatePipe implements PipeTransform {
    readonly translateValuePipe = inject(TranslateValuePipe);

    transform(value: string, separator: string, onlyLast: boolean = false, extraTranslationGroups?: string[]): string {
        let splits = value ? value.split(separator) : [];

        if (onlyLast) {
            const last = splits.pop();
            if (last) splits = [splits.join(separator), last];
        }

        const result = splits.map((word: string) => {
            return this.translateValuePipe.transform(word, extraTranslationGroups);
        });

        return result.join(separator);
    }
}
